import { isBetween, isFloat, isNumeric, random, range, serial, sequence } from "../number.ts";
Number.isFloat = isFloat;
Number.isNumeric = isNumeric;
Number.isBetween = isBetween;
Number.random = random;
Number.range = range;
Number.serial = serial;
Number.sequence = sequence;
//# sourceMappingURL=number.js.map